import { render, staticRenderFns } from "./importData.vue?vue&type=template&id=4cf802b8&scoped=true"
import script from "./importData.vue?vue&type=script&lang=js"
export * from "./importData.vue?vue&type=script&lang=js"
import style0 from "./importData.vue?vue&type=style&index=0&id=4cf802b8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf802b8",
  null
  
)

export default component.exports